import '../reset.css';
import '../style.css';
import '../scripts/common.js';
import {initIframeResize} from './_inIFrame.js';

import {initApplicationForm} from './apply/_applyCommon.js';
import '../styles/form_styles.css';

initApplicationForm('dp');

initIframeResize();
